import { SofaFormValidator } from '@sofology/sofologycomponents';

import { ValidateDescription, ValidateOperatorTypeDescription } from 'models';
import { isValidByOperator } from './formValidators';
import UkModulusChecking from 'uk-modulus-checking';

const FULL_FILLED_SORT_CODE_LENGTH = 6;
const SORT_CODE_SPLIT_SYMBOL_REGEXP = /-/g;

// Case to use: if external value (from the same or different form) meets validation condition, then current value is required'.
export const stringRequiredIfValidator = (errorMessage: string, getExternalValue: () => () => string, expectedExternalValue: string, operator: ValidateOperatorTypeDescription): SofaFormValidator<string> => (value: string) => {
    let externalValue = getExternalValue()();

    let shouldBeValidated = expectedExternalValue ? false : isValidByOperator<string>(externalValue, expectedExternalValue, operator);
    let required = shouldBeValidated ? !value : false;

    return Promise.resolve(required ? errorMessage : null);
};

export const compareStringsByOperatorValidator = (errorMessage: string, getExternalValue: () => () => string, operator: ValidateOperatorTypeDescription): SofaFormValidator<string> => (value: string) => {
    let externalValue = getExternalValue()();

    return Promise.resolve(value ? null : isValidByOperator<string>(value, externalValue, operator) ? errorMessage : null);
};

export const conditionStringsValidator = (validateDescription: ValidateDescription): SofaFormValidator<string> => (value: string) => {
    const conditionResult = createCondition(validateDescription.expression, value);

    return Promise.resolve(conditionResult ? null : validateDescription.message);
};

export const bankDataValidator = (errorMessage: string, getExternalValue: () => () => string): SofaFormValidator<string> => (value: string) => {
    let accountNumber = getExternalValue()();
    let sortCode = value.replace(SORT_CODE_SPLIT_SYMBOL_REGEXP, '');

    let isSortCodeFilled = sortCode.length === FULL_FILLED_SORT_CODE_LENGTH;
    let isValid;

    if (isSortCodeFilled) {
        isValid = new UkModulusChecking({ accountNumber: accountNumber, sortCode }).isValid();
    } else {
        isValid = true;
    }

    return Promise.resolve(isValid ? null : errorMessage);
};

const createCondition = (expression: string, value: string): boolean => {
    const valueKey = 'value';

    const conditionFunction = new Function(valueKey, `return \`${expression}\`;`);

    return conditionFunction(value) === 'true';
};